export class DropdownModelFacilities {
    constructor(public id: number, public icon: string, public name: string) { }
  }
